import {isEmpty, isNil} from 'lodash';

export function isNilEmpty(
  value: any
): value is null | undefined | '' | Record<string, never> {
  return isNil(value) || isEmpty(value);
}
